module.exports = __webpack_public_path__ + "cd8efa921550bcd992ae8bcdae289e53.MP3";